(function () {
  'use strict'

  function initClipPathAnimation () {
    const cards = document.querySelectorAll('.nail-colors-showcase__card')
    const visibleThreshold = 0.2

    if (!cards.length) return

    if (!('IntersectionObserver' in window)) {
      cards.forEach(card => {
        card.classList.add('nail-colors-showcase__card--animated')
        card.style.setProperty('--animation-progress', 1)
      })
      return
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const card = entry.target
        const isVisible = entry.isIntersecting && entry.intersectionRatio >= visibleThreshold

        if (isVisible) {
          card.classList.add('nail-colors-showcase__card--animated')
          card.style.setProperty('--animation-progress', 1)
        } else {
          card.classList.remove('nail-colors-showcase__card--animated')
          card.style.setProperty('--animation-progress', 0)
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold: [0, visibleThreshold]
    })

    cards.forEach(card => {
      observer.observe(card)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClipPathAnimation)
  } else {
    initClipPathAnimation()
  }
})()
